<msi-content-modal #modal [items]="[{}]" [modalRef]="modalRef">
	<div class="msi-content-modal-item config-modal">
		<div class="top-bar">
			<span class="mt-1"><b i18n>Select a workspace to create a workflow in</b></span>
		</div>
		<div class="inner-container">
			<div class="search-bar-container msi-flex-col">
				<div class="search-bar-text-container msi-flex-col">
					<span i18n class="search-bar-text">Select a workspace</span>
					<span i18n class="search-bar-text-desc"
						>Select a workspace to create a workflow in or press Create New Workspace.</span
					>
				</div>
				<div class="search-bar">
					<msi-autocomplete-v2
						id="selectWorkspaceToCreateWorkflowAutocomplete"
						#selectWorkspaceAutocomplete
						i18n-placeholder
						placeholder="Search"
						[options]="workspaces"
						[sortOptions]="false"
						[minSearchCharacters]="0"
						[asyncDataProvider]="true"
						[dynamicWidthMenu]="true"
						[isDataLoading]="workspacesLoading"
						(optionSelection)="selectWorkspace($event.selectedOption?.id)">
					</msi-autocomplete-v2>
				</div>
			</div>
			<div class="button-container msi-flex-row">
				<button
					i18n
					id="createNewWorkspaceButton"
					[disabled]="!canUserCreateNewWorkspaces"
					class="msi-btn msi-btn-action cancel-save-buttons"
					(click)="openNewWorkspaceConfigModal()">
					Create New Workspace
				</button>
				<div class="cancel-save-button-container mr-2">
					<button
						i18n
						id="cancelWorkspaceEditButton"
						class="msi-btn msi-btn-secondary cancel-btn"
						[disabled]="cancelButtonDisabled"
						(click)="cancelClickHandler()">
						Cancel
					</button>
					<button
						i18n
						id="saveWorkspaceEditButton"
						class="msi-btn save-btn"
						msiTooltip="{{ workspaces.length === 0 ? atLeastOneWorkspaceRequiredTooltip : selectAWorkspaceTooltip }}"
						[tooltipDisabled]="selectedWorkspaceId !== null"
						[showDelay]="500"
						[disabled]="selectedWorkspaceId === null || !canUserEditWorkflow"
						(click)="saveClickHandler()">
						Continue
					</button>
				</div>
			</div>
		</div>
	</div>
</msi-content-modal>

<!-- Copyright (c) Motorola Solutions Inc. All Rights Reserved. -->
